import { z } from "zod";

export type HistoryCreationInput<T extends object, K extends string = "id"> = {
  original: T | null;
  updated: T & Record<K, string>;
  bidId: number;
};

// History changedFrom/changedTo are String()-serialized (packages/history/src/generate-history.ts), so a
// boolean renders as "true"/"false". Gate on the literal strings and transform — z.coerce.boolean() would
// read "false" as true (Boolean("false") === true). Unexpected values fail closed to null.
export const HistoryStringBooleanSchema = z
  .enum(["true", "false"])
  .transform((value) => value === "true")
  .nullable()
  .catch(null);
